import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import FundingEnquiryUserEntity from './FundingEnquiryUserEntityModel';

const FundingEnquiryUserRecord = Record({
  entity: null,
  id: 0,
  name: '',
});

export default class FundingEnquiryUser extends FundingEnquiryUserRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      entity: FundingEnquiryUserEntity.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new FundingEnquiryUser(hydrated);
  }
}
